import { EntityBanner, RawEntityBanner } from '../interfaces/entity-banner';

export function EntityBannersFactory<A>(rawBanners: RawEntityBanner<A>[]): EntityBanner<A>[] {
  return rawBanners.map(rawBanner => ({
    title: rawBanner.title,
    content: rawBanner.content,
    type: rawBanner.type,
    actions: rawBanner.actions ?? [],
    docLink: rawBanner.doc_link
  }));
}
